<template>
<div class="m-sixthstar">
  <template v-if="!loading">
    <div id="m-sixthstar__hero" class="m-sixthstar__hero" v-observe-visibility="observeVisibilitySettings(0, 'Header')">
      <h1>MapleStory The Sixth Star</h1>
      <div class="m-sixthstar__hero__logo"></div>
      <div class="m-sixthstar__hero__title">Prepare for the new power arriving in MapleStory later this year with the <span>Journey Toward the Sixth Star Event</span>!</div>
      <div class="m-sixthstar__hero__button" @click="playFree"><span>PLAY FREE!</span></div>
    </div>

    <div class="m-sixthstar__sixth-star-coming" v-observe-visibility="observeVisibilitySettings(1, '6th star is coming')">

      <div class="m-sixthstar__sixth-star-coming__title">
        <span>The Sixth Star Is Coming!</span>
      </div>

      <div class="m-sixthstar__sixth-star-coming__text">A new star is coming to Maple World, a new source of power beyond anything that's come before. The heroes of MapleStory must collect star fragments to create the Sixth Star and unlock its power.</div>
      <div class="m-sixthstar__sixth-star-coming__text">In the November update, MapleStory will unveil Sixth Job powers, featuring new skills and new buffs for every single MapleStory class, from the classic Explorers to the newly released Khali.</div>
      <div class="m-sixthstar__sixth-star-coming__text">The Sixth Job quests will become available at Lv. 260, with new story content, new quests to complete, and greater foes to test your newfound power in MapleStory!</div>

      <div class="m-sixthstar__sixth-star-coming__in">Coming in November 2023!</div>
    </div>

    <div class="m-sixthstar__sixth-star-events" v-observe-visibility="observeVisibilitySettings(2, '6th star event')">

      <div class="m-sixthstar__sixth-star-events__title"><span>Journey Toward the Sixth Star Event</span></div>

      <div class="m-sixthstar__sixth-star-events__content">
        <div class="m-sixthstar__sixth-star-events__content__text">Terry, a new arrival to Maple World, has followed the energy of the Sixth Star, and is eager to help the heroes of Maple World connect to this new power. Join him and learn how to collect the power of the star, and earn a wealth of rewards as well!</div>

        <div class="m-sixthstar__sixth-star-events__content__img"></div>

        <div class="m-sixthstar__sixth-star-events__content__text">During the first five Chapters of the event, you'll be given a Daily Mission to complete, as well as a set of 10 challenges to work towards.</div>

        <div class="m-sixthstar__sixth-star-events__content__text">By completing <span>10 Daily Missions</span> and <span>5 Challenges</span>, you'll claim the rewards for that Chapter, including a Star Piece!</div>

        <div class="m-sixthstar__sixth-star-events__content__text">Collect all six Star Pieces throughout the event, and trade them back to Terry to get <span>Terry's Hexagonal Star</span>, a unique item with a special appearance to remind you of your adventures together!</div>
      </div>
    </div>

    <div class="m-sixthstar__sixth-star-chapters" v-observe-visibility="observeVisibilitySettings(3, 'Chapters', 0.1)">

      <div v-for="(chapter, chapterIndex) in chapters" :key="chapterIndex" class="m-sixthstar__chapter-box">
        <div v-if="chapter.live" class="m-sixthstar__chapter" :class="[`m-sixthstar__chapter--${chapterIndex}`, {'m-sixthstar__chapter--complete': chapter.live && !chapter.active }]">
          <div class="m-sixthstar__chapter__head" :class="{'m-sixthstar__chapter__head--active': chapter.active}">
            <div class="m-sixthstar__chapter__head__title">{{ chapter.title  }}</div>
            <div v-if="chapter.active" class="m-sixthstar__chapter__head__status">Now Active!</div>
            <div class="m-sixthstar__chapter__head__date"><span>{{ chapter.date }}</span></div>
          </div>

          <div class="m-sixthstar__chapter__content">
            <div v-for="(item, index) in chapter.items" :key="`item-${index}`" class="m-sixthstar__chapter__content__row" :class="`order-${item.mobileOrder}`">
              <div v-if="item.img" class="m-sixthstar__chapter__content__item">
                <img :src="require(`@/assets/images/microsites/sixthstar/chapters/${chapterIndex}/${item.img}.png`)" alt="">
              </div>
              <div class="m-sixthstar__chapter__content__desc">
                <div v-html="item.desc" />
              </div>
              <div class="m-sixthstar__chapter__content__descImg" v-if="item.descImg">
                <img :src="require(`@/assets/images/microsites/sixthstar/chapters/${chapterIndex}/${item.descImg}.png`)" alt="">
              </div>
            </div>
          </div>
        </div>

        <div v-else class="m-sixthstar__chapter-coming" :class="`m-sixthstar__chapter-coming--${chapterIndex}`">

        </div>
      </div>

      <div class="m-sixthstar__sixth-star-chapters__learn">Learn the full details in the <a href="https://maplestory.nexon.net/news/85576" target="_blank" @click="clickTracking({
        interaction: 'link_click',
        sectionNumber: 3,
        sectionName: 'Chapters',
        sectionContent: 'Chapter II Post',
      })">Journey Toward the Sixth Star Event Chapter III post</a>!</div>
    </div>


    <Footer
      color="#ffffff"
      hoverColor="#d5e3f1"
      backgroundColor="#1b1f3d"
      @go-to-main-click="clickTracking({
        interaction: 'link_click',
        sectionNumber: 4,
        sectionName: 'Footer',
        sectionContent: 'Main Site',
      })"
      @link-click="(name) => clickTracking({
        interaction: 'link_click',
        sectionNumber: 4,
        sectionName: 'Footer',
        sectionContent: name,
      })"
      v-observe-visibility="observeVisibilitySettings(4, 'Footer')"
    />
  </template>
</div>
</template>

<script>
import Util from '@/services/browser/Util';
import Cookie from '@/services/browser/Cookie';
import Responsive from '@/services/browser/Responsive'
import Footer from '@/components/microsites/Footer.vue'
import '@/assets/scss/microsites/SixthStar/_SixthStar.scss'
import { defineComponent } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'

export default defineComponent({
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  name: 'Microsite BossBlitz',
  components: {
    Footer,
  },
  props: {},
  data() {
    return {
      loading: true,
      chapters: {
        1: {
          live: true,
          active: false,
          title: 'Chapter I',
          date: 'July 19 - August 8 UTC',
          items: [
            {
              img: '1',
              desc: 'Chapter I Completion Box',
              mobileOrder: 1,
            },
            {
              img: '2',
              desc: 'Chapter I EXP Potion',
              mobileOrder: 3,
            },
            {
              img: '3',
              desc: 'Arcane Symbol Selection Coupon',
              mobileOrder: 5,
            },
            {
              img: '4',
              desc: 'Arcane Umbra Weapon Box',
              mobileOrder: 7,
            },
            {
              img: '5',
              desc: 'Shiny Prestige Box',
              mobileOrder: 2,
            },
            {
              img: '6',
              desc: 'Karma Solid Cube',
              mobileOrder: 4,
            },
            {
              img: '7',
              desc: 'Lil Terry Pet Package',
              mobileOrder: 6,
            },
            {
              img: '8',
              desc: 'First Star Piece',
              mobileOrder: 8
            },
          ]
        },
        2: {
          live: true,
          active: false,
          title: 'Chapter II',
          date: 'August 9 - August 29 UTC',
          items: [
            {
              img: '1',
              desc: 'Chapter II Completion Box',
              mobileOrder: 1,
            },
            {
              img: '2',
              desc: 'Chapter II EXP Potion',
              mobileOrder: 3,
            },
            {
              img: '3',
              desc: 'Nodestone',
              mobileOrder: 5,
            },
            {
              img: '4',
              desc: 'Dominator Pendant Box',
              mobileOrder: 7,
            },
            {
              img: '5',
              desc: 'Special Trait Boost Potion',
              mobileOrder: 2,
            },
            {
              img: '6',
              desc: 'Karma Bonus Epic Potential Scroll 100%',
              mobileOrder: 4,
            },
            {
              img: '7',
              desc: 'Karma Unique Potential Scroll 100%',
              mobileOrder: 6,
            },
            {
              img: '8',
              desc: 'Radiant Star Pop Mount Coupon',
              mobileOrder: 8
            },
            {
              img: '9',
              desc: 'Second Star Piece',
              mobileOrder: 9
            },
          ]
        },
        3: {
          live: true,
          active: true,
          title: 'Chapter III',
          date: 'August 30 - September 19 UTC',
          items: [
            {
              img: '1',
              desc: 'Chapter III Completion Box',
              mobileOrder: 1,
            },
            {
              img: '2',
              desc: 'Chapter III EXP Potion',
              mobileOrder: 3,
            },
            {
              img: '3',
              desc: 'Karma Legendary Potential Scroll 100%',
              mobileOrder: 5,
            },
            {
              img: '4',
              desc: 'Unique Frozen Secondary Weapon Box',
              mobileOrder: 7,
            },
            {
              img: '5',
              desc: 'Weekly Boss Clear Count Reset Ticket',
              mobileOrder: 2,
            },
            {
              img: '6',
              desc: 'Event Ring Exclusive Legendary Potential Scroll 100%',
              mobileOrder: 4,
            },
            {
              img: '7',
              desc: 'Terryroid Coupon',
              mobileOrder: 6,
            },
            {
              img: '8',
              desc: 'Third Star Piece',
              mobileOrder: 8
            }
          ]
        },
        4: {
          live: false,
          active: false,
          title: 'Chapter IV',
          date: 'September 20 - October 10 UTC',
          items: [
            {
              img: '1',
              desc: 'Chapter IV Completion Box',
              mobileOrder: 1,
            },
            {
              img: '2',
              desc: 'Chapter IV EXP Potion',
              mobileOrder: 3,
            },
            {
              img: '3',
              desc: 'Karma Solid Cube',
              mobileOrder: 5,
            },
            {
              img: '4',
              desc: 'Prepared Pendant of the Spirit Coupon',
              mobileOrder: 7,
            },
            {
              img: '5',
              desc: 'Experience Nodestone',
              mobileOrder: 2,
            },
            {
              img: '6',
              desc: 'Pure Clean Slate Scroll 100%',
              mobileOrder: 4,
            },
            {
              img: '7',
              desc: 'Hexagonal Star Glass Marble Chair',
              mobileOrder: 6,
            },
            {
              img: '8',
              desc: 'Fourth Star Piece',
              mobileOrder: 8
            }
          ]
        },
        5: {
          live: false,
          active: false,
          title: 'Chapter V',
          date: 'October 11 - October 30 UTC',
          items: [
            {
              img: '1',
              desc: 'Chapter V Completion Box',
              mobileOrder: 1,
            },
            {
              img: '2',
              desc: 'Chapter V EXP Potion',
              mobileOrder: 3,
            },
            {
              img: '3',
              desc: 'Karma Rare Bonus Glowing Cube',
              mobileOrder: 5,
            },
            {
              img: '4',
              desc: 'Spell Trace',
              mobileOrder: 7,
            },
            {
              img: '5',
              desc: 'Legendary Emblem Box',
              mobileOrder: 2,
            },
            {
              img: '6',
              desc: 'Sacred Symbol Selection Coupon',
              mobileOrder: 4,
            },
            {
              img: '7',
              desc: 'Mitra\'s Black Rebirth Flame Box',
              mobileOrder: 6,
            },
            {
              img: '8',
              desc: 'Starlight Adventurer Set Coupon',
              mobileOrder: 8
            },
            {
              img: '9',
              desc: 'Fifth Star Piece',
              mobileOrder: 9
            },
            {
              img: '10',
              desc: 'Sixth Star Piece',
              mobileOrder: 10
            },
          ]
        },
        6: {
          live: false,
          active: false,
          title: 'Chapter VI',
          date: 'November 1 - November 14 UTC',
          items: [
            {
              desc: 'Log in 5 days during Chapter VI for one last set of prizes, the <span>Star Title Coupon</span> and <span>Starlight Energy Chair</span>!',
              mobileOrder: 1,
            },
            {
              img: '2',
              desc: 'Chapter VI Completion Box',
              mobileOrder: 3,
            },
            {
              img: '3',
              desc: 'Star Title Coupon',
              descImg: 'icon-3',
              mobileOrder: 5,
            },
            {
              img: '4',
              desc: ' Starlight Energy Chair',
              descImg: 'icon-4',
              mobileOrder: 7,
            },
          ]
        },
      }
    }
  },
  mounted() {
    Responsive.init();
    setTimeout(() => {
      // wait for the responsive init
      this.loading = false;

      window.dataLayer.push({
        pageType:       'Microsite',
        micrositeName:  '6th Star',
        micrositePhase: '3'
      })
    }, 210);
    Cookie.set("maplesixthstar", "true");
  },
  methods: {
    playFree(){
      Util.playFree();
      this.clickTracking({
        interaction: 'button_click',
        sectionNumber: 0,
        sectionName: 'Header',
        sectionContent: 'Play Free CTA',
      })
    },
    observeVisibilitySettings(id, name, threshold = 0.3) {
      return {
        callback: (isVisible) => isVisible ? this.viewTracking({ id, name }) : null,
        intersection: { threshold: threshold },
        throttle: 1000,
        once: true,
      }
    },
    clickTracking({ interaction, sectionNumber, sectionName, sectionContent, specialValue }) {
      window.dataLayer.push({
        event: 'standardMicrositeTrackingEvent',
        interaction: interaction,
        micrositeSectionNumber: sectionNumber,
        micrositeSectionName: sectionName,
        micrositeSectionContent: sectionContent,
        ...(specialValue ? { micrositeSpecialValue: specialValue } : {}),
      });
    },
    viewTracking({ id, name }) {
        window.dataLayer.push({
          'event': 'standardMicrositeTrackingEvent',
          'interaction': 'section_view',
          'micrositeSectionNumber': id,
          'micrositeSectionName': name,
        });
    },
  },
})
</script>